import React from "react";

const GeoLocations = () => {
    return <div>Geo Locations</div>;
};

export default GeoLocations;